function gradeFromScore(score) {
  if (score >= 90) return 'A'
  if (score >= 80) return 'B'
  if (score >= 60) return 'C'
  return 'D'
}

function averageScores(items) {
  const scores = (items || []).map(item => Number(item.score) || 0).filter(score => score > 0)
  if (!scores.length) return 0
  return Math.round(scores.reduce((sum, score) => sum + score, 0) / scores.length)
}

function getBody(config) {
  if (!config.body) return {}
  if (typeof config.body === 'object') return config.body
  try {
    return JSON.parse(config.body)
  } catch (error) {
    return {}
  }
}

const MOCK_SERIAL = '123456789012345678'

const activity = {
  id: 1,
  schoolName: '上海民办华曜宝山实验学校',
  className: '26.9 YES 科学',
  bookId: 1,
  bookTitle: 'The Little Red Hen',
  bookCover: 'https://via.placeholder.com/800x320/FFB6C1/333333?text=Lesson+Cover',
  published: true,
  students: [
    { id: 'seed-student-001', name: '示例学生' },
    { id: 'seed-student-002', name: '小明' }
  ]
}

const studentSerials = {
  'seed-student-001': MOCK_SERIAL,
  'seed-student-002': '876543210987654321'
}

const unlockedLessonIndexes = [0, 1]

const lessons = [
  {
    index: 0,
    title: 'Lesson 1',
    lessonId: 'buzz-segment-1',
    lineCount: 2,
    wordCount: 2,
    lines: [
      { id: 'buzz-line-1', order: 1, text: 'Hello! I am Buzz.', audioUrl: '' },
      { id: 'buzz-line-2', order: 2, text: 'I am fast.', audioUrl: '' }
    ],
    words: [
      { id: 1, word: 'hen', phonetic: '/hen/', meaning: '母鸡', audioUrl: '', example: 'The hen found seeds.' },
      { id: 2, word: 'wheat', phonetic: '/wiːt/', meaning: '小麦', audioUrl: '', example: 'Wheat grows in the field.' }
    ]
  },
  {
    index: 1,
    title: 'Lesson 2',
    lessonId: 'buzz-segment-2',
    lineCount: 1,
    wordCount: 2,
    lines: [
      { id: 'buzz-line-3', order: 1, text: 'I like to fly.', audioUrl: '' }
    ],
    words: [
      { id: 3, word: 'seed', phonetic: '/siːd/', meaning: '种子', audioUrl: '', example: 'Plant the seed.' },
      { id: 4, word: 'plant', phonetic: '/plænt/', meaning: '种植', audioUrl: '', example: 'Who will plant these seeds?' }
    ]
  },
  {
    index: 2,
    title: 'Lesson 3',
    lessonId: 'buzz-segment-3',
    lineCount: 1,
    wordCount: 1,
    lines: [
      { id: 'buzz-line-4', order: 1, text: 'Can you help me?', audioUrl: '' }
    ],
    words: [
      { id: 5, word: 'help', phonetic: '/help/', meaning: '帮助', audioUrl: '', example: 'Can you help me?' }
    ]
  }
]

/** @type {Record<string, { bestScore: number, grade: string }>} */
const lessonResults = {}

function resultKey(studentId, lessonIndex) {
  return `${studentId}:${lessonIndex}`
}

function getActivityId(url) {
  const match = String(url || '').match(/\/api\/activities\/(\d+)/)
  return match ? parseInt(match[1], 10) : 0
}

function getLessonIndex(url) {
  const match = String(url || '').match(/\/lessons\/(\d+)/)
  return match ? parseInt(match[1], 10) : -1
}

function getStudentIdFromConfig(config) {
  const headers = (config && config.headers) || {}
  const auth = headers.Authorization || headers.authorization || headers['X-Token'] || headers['x-token'] || ''
  const token = String(auth).replace(/^Bearer\s+/i, '')
  const match = token.match(/^student:([^:]+):activity:/)
  if (match) return match[1]
  return activity.students[0].id
}

export default [
  {
    url: '/api/activities/[0-9]+$',
    type: 'get',
    response: config => {
      const id = getActivityId(config.url)
      if (id !== activity.id) {
        return { code: 404, message: '活动不存在', data: null }
      }

      return {
        code: 20000,
        message: 'success',
        data: {
          id: activity.id,
          schoolName: activity.schoolName,
          className: activity.className,
          bookTitle: activity.bookTitle,
          bookCover: activity.bookCover,
          published: activity.published,
          students: activity.students
        }
      }
    }
  },

  {
    url: '/api/activities/[0-9]+/login',
    type: 'post',
    response: config => {
      const id = getActivityId(config.url)
      const body = getBody(config)
      if (id !== activity.id) {
        return { code: 404, message: '活动不存在', data: null }
      }
      if (!activity.published) {
        return { code: 40302, message: '活动未上架', data: null }
      }
      if (!body.studentId || !body.serialCode) {
        return { code: 40001, message: '缺少参数', data: null }
      }

      const student = activity.students.find(item => item.id === body.studentId)
      const expected = studentSerials[body.studentId]
      if (!student || !expected || String(body.serialCode).trim() !== expected) {
        return { code: 40004, message: '学生或序列号不正确', data: null }
      }

      return {
        code: 20000,
        message: '登录成功',
        data: {
          studentId: student.id,
          studentName: student.name,
          activityId: activity.id,
          schoolName: activity.schoolName,
          className: activity.className,
          bookId: activity.bookId,
          bookTitle: activity.bookTitle,
          token: `student:${student.id}:activity:${activity.id}:exp:mock`,
          expiresIn: 86400 * 7
        }
      }
    }
  },

  {
    url: '/api/activities/[0-9]+/lessons$',
    type: 'get',
    response: config => {
      const id = getActivityId(config.url)
      if (id !== activity.id) {
        return { code: 404, message: '活动不存在', data: null }
      }

      const studentId = getStudentIdFromConfig(config)
      const student = activity.students.find(item => item.id === studentId) || activity.students[0]
      return {
        code: 20000,
        message: 'success',
        data: {
          activityId: activity.id,
          schoolName: activity.schoolName,
          className: activity.className,
          studentName: student.name,
          bookTitle: activity.bookTitle,
          bookCover: activity.bookCover,
          lessons: lessons.map(lesson => {
            const unlocked = unlockedLessonIndexes.indexOf(lesson.index) > -1
            const result = lessonResults[resultKey(studentId, lesson.index)]
            return {
              index: lesson.index,
              title: lesson.title,
              unlocked,
              learned: !!result,
              grade: result ? result.grade : null,
              bestScore: result ? result.bestScore : null,
              lineCount: lesson.lineCount,
              wordCount: lesson.wordCount
            }
          })
        }
      }
    }
  },

  {
    url: '/api/activities/[0-9]+/lessons/[0-9]+$',
    type: 'get',
    response: config => {
      const id = getActivityId(config.url)
      const lessonIndex = getLessonIndex(config.url)
      if (id !== activity.id) {
        return { code: 404, message: '活动不存在', data: null }
      }
      if (unlockedLessonIndexes.indexOf(lessonIndex) < 0) {
        return { code: 40303, message: '课程未开启或不存在', data: null }
      }

      const lesson = lessons.find(item => item.index === lessonIndex)
      if (!lesson) {
        return { code: 40303, message: '课程未开启或不存在', data: null }
      }

      return {
        code: 20000,
        message: 'success',
        data: {
          activityId: activity.id,
          bookId: activity.bookId,
          bookTitle: activity.bookTitle,
          lessonIndex: lesson.index,
          lessonId: lesson.lessonId,
          title: lesson.title,
          unlocked: true,
          lines: lesson.lines,
          words: lesson.words
        }
      }
    }
  },

  {
    url: '/api/activities/[0-9]+/lessons/[0-9]+/complete',
    type: 'post',
    response: config => {
      const id = getActivityId(config.url)
      const lessonIndex = getLessonIndex(config.url)
      if (id !== activity.id) {
        return { code: 404, message: '活动不存在', data: null }
      }
      if (unlockedLessonIndexes.indexOf(lessonIndex) < 0) {
        return { code: 40004, message: '提交失败，请确认课程已开启并完成测评', data: null }
      }

      const body = getBody(config)
      const attemptScore = averageScores(body.items)
      if (attemptScore <= 0) {
        return { code: 40004, message: '提交失败，请确认课程已开启并完成测评', data: null }
      }

      const studentId = getStudentIdFromConfig(config)
      const key = resultKey(studentId, lessonIndex)
      const existing = lessonResults[key]
      const bestScore = existing ? Math.max(existing.bestScore, attemptScore) : attemptScore
      const grade = gradeFromScore(bestScore)
      lessonResults[key] = { bestScore, grade }

      return {
        code: 20000,
        message: '提交成功',
        data: {
          learned: true,
          bestScore,
          grade,
          attemptScore
        }
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/mock/activity.js